import React from "react";

import AboutPhotos from "./AboutPhotos";
import Button from "../button/Button";

function About() {
  return (
    <div className="post__injectable">
      <div className="about">
        <AboutPhotos />
        <p className="about__text">
          Accesto is a boutique software house focused on software craftsmanship
          and partnership. Founded in 2010 we have helped over 50 projects to
          overcome their technical challenges and outpace competition.
        </p>
        <Button text href="https://accesto.com/about/">
          LEARN MORE
        </Button>
      </div>
    </div>
  );
}

export default About;
